<template>

  <ValidationObserver ref="loginForm" slim>
    <b-form @submit.prevent="register" class="clearfix mb-3">
      <ValidationProvider
          name="Agency name"
          :rules="{ required: true }"
          v-slot="vContext"
        >
        <b-form-group
          :label="$gettext('Agency name') + ':'" label-class="pt-0" label-for="agency">
          <b-input
            type="text"
            name="agency"
            id="agency"
            v-model="register.agency"
            :placeholder="$gettext('agency name')"
            size="sm"
            :state="getValidationState(vContext)"
            aria-describedby="agency"
          />
          <b-form-invalid-feedback id="agency">{{ vContext.errors[0] }}</b-form-invalid-feedback>
        </b-form-group>
      </ValidationProvider>
      <ValidationProvider
          name="vat"
          :rules="{ required: true }"
          v-slot="vContext"
        >
        <b-form-group
          :label="$gettext('VAT no') + ':' "
          label-class="pt-0"
          label-for="vat">
          <b-input
            type="text"
            name="vat"
            id="vat"
            v-model="register.vat"
            :placeholder="$gettext('vat no')"
            size="sm"
            :state="getValidationState(vContext)"
            aria-describedby="vat"
          />
          <b-form-invalid-feedback id="vat">{{ vContext.errors[0] }}</b-form-invalid-feedback>
        </b-form-group>
      </ValidationProvider>
      <ValidationProvider
          name="company_no"
          :rules="{ required: true }"
          v-slot="vContext"
        >
        <b-form-group
          :label="$gettext('Unique registration code') + ':'"
          label-class="pt-0"
          label-for="company_no">
          <b-input
            type="text"
            name="company_no"
            id="company_no"
            v-model="register.regcom"
            :placeholder="$gettext('company no')"
            size="sm"
            :state="getValidationState(vContext)"
            aria-describedby="company_no"
          />
          <b-form-invalid-feedback id="company_no">{{ vContext.errors[0] }}</b-form-invalid-feedback>
        </b-form-group>
      </ValidationProvider>
      <ValidationProvider
        name="Email"
        :rules="{required: true}"
        v-slot="vContext"
        >
        <b-form-group
          :label="$gettext('Email address') + ':'"
          label-class="pt-0"
          label-for="Adresa">
          <b-input
            type="email"
            name="email"
            id="email"
            v-model="register.email"
            :placeholder="$gettext('email address')"
            size="sm"
            :state="getValidationState(vContext)"
            aria-describedby="email"
          />
          <b-form-invalid-feedback id="email">{{ vContext.errors[0] }}</b-form-invalid-feedback>
        </b-form-group>
      </ValidationProvider>
      <ValidationProvider
        name="Telephone"
        :rules="{required: true}"
        v-slot="vContext"
        >
        <b-form-group
          :label="$gettext('Telephone number') + ':'"
          label-class="pt-0"
          label-for="telefon">
          <b-input
            type="text"
            name="telephone"
            id="telephone"
            v-model="register.phone"
            :placeholder="$gettext('telephone number')"
            size="sm"
            :state="getValidationState(vContext)"
            aria-describedby="telephone"
          />
          <b-form-invalid-feedback id="telephone">{{ vContext.errors[0] }}</b-form-invalid-feedback>
        </b-form-group>
      </ValidationProvider>
      <ValidationProvider
        name="Contact"
        :rules="{required: true}"
        v-slot="vContext"
        >
        <b-form-group
          :label="$gettext('Contact person') + ':'"
          label-class="pt-0"
          label-for="nume">
          <b-input
            type="text"
            name="contact_person"
            id="contact_person"
            v-model="register.name"
            :placeholder="$gettext('contact person')"
            size="sm"
            :state="getValidationState(vContext)"
            aria-describedby="contact_person"
          />
          <b-form-invalid-feedback id="contact_person">{{ vContext.errors[0] }}</b-form-invalid-feedback>
        </b-form-group>
      </ValidationProvider>
      <ValidationProvider
        name="address"
        :rules="{required: true}"
        v-slot="vContext"
        >
        <b-form-group
          :label="$gettext('Address') + ':'"
          label-class="pt-0"
          label-for="address">
          <b-input
            type="text"
            name="address"
            id="address"
            v-model="register.address"
            :placeholder="$gettext('address')"
            size="sm"
            :state="getValidationState(vContext)"
            aria-describedby="address"
          />
          <b-form-invalid-feedback id="address">{{ vContext.errors[0] }}</b-form-invalid-feedback>
        </b-form-group>
      </ValidationProvider>
      <div class="clearfix">
        <b-button type="submit" variant="warning" class="float-right mt-3" v-translate>
          Send
        </b-button>
      </div>
      <hr>
      <p class="text-center py-1">
        <translate>Login</translate>
        <router-link :to="{ name: 'Public/Login' }" class="link">&nbsp;<translate>click here</translate></router-link>
      </p>
    </b-form>
  </ValidationObserver>

</template>

<script>
import validation from 'b2b-common/mixins/validation'

export default {
  name: 'Subscribe',
  mixins: [validation],
  data () {
    return {
      register: {
        agency: '',
        vat: '',
        regcom: '',
        email: '',
        phone: '',
        name: '',
        address: ''
      }
    }
  }
}
</script>
